export class EnvService {
  // Base URL configuration for reusability (includes protocol)
  private BASE_URL = 'https://develop.analytiko.net/'; //34.172.101.209

  // API URLs using the base URL
  public URL_API = `${this.BASE_URL}:3000`;
  public URL_API_V1 = `${this.BASE_URL}:3100/v1`;
  public URL_SOCKET_V1 = `${this.BASE_URL}:3100`;
  public URL_NEO4J = 'bolt://localhost:7687'; //'bolt://localhost:7687'
  public URL_FORSKER = `${this.BASE_URL}:5110/api/prompt_route`;
  public URL_MALLA = `${this.BASE_URL}:3000/v1`;

  // Transfer API Configuration using base URL
  public URL_TRANSFER_API = `${this.BASE_URL}:3400/api/transfers`;

  public version_front = '2.34.170';
  public version_back = '2.25.92';

  constructor() {}
}
